import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import { Button } from '@mui/material'
import { useEffect, useState } from 'react'
import Form from '../form/Form'

function EventDialog(props) {
  const { onClose, setEvent, onCancel, event: eventProp, open, ...other } = props
  const [checkForm, setCheckForm] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)

  const options = {
    fields: [
      [
        {
          name: 'start',
          label: 'Date Début',
          type: 'datetime',
          validation: [{ rule: 'req', error: 'Date Début obligatoire' }],
          onDateChange: (newValue) =>
            setEvent((prev) => ({
              ...prev,
              start: newValue.format('YYYY-MM-DDTHH:mm:ss')
            }))
        }
      ],
      [
        {
          name: 'end',
          label: 'Date Fin',
          type: 'datetime',
          validation: [
            { rule: 'req', error: 'Date Fin obligatoire' },
            { rule: 'after=start', error: 'Date Fin doit être après date Début' }
          ],
          onDateChange: (newValue) =>
            setEvent((prev) => ({
              ...prev,
              end: newValue.format('YYYY-MM-DDTHH:mm:ss')
            }))
        }
      ],
      [
        {
          name: 'title',
          label: 'Titre',
          type: 'text',
          validation: [{ rule: 'req', error: 'Titre obligatoire' }]
        }
      ],
      [
        {
          name: 'description',
          label: 'Description',
          type: 'text',
          validation: [{ rule: 'req', error: 'Description obligatoire' }]
        }
      ],
      [
        {
          name: 'type',
          label: 'Type',
          type: 'text'
        }
      ]
    ],
    data: eventProp
  }

  useEffect(() => {
    setEvent(eventProp)
  }, [eventProp, setEvent])

  useEffect(() => {
    if (isSubmit) {
      setIsSubmit(false)
      onClose()
    }
  }, [isSubmit, onClose])

  const handleCancel = () => {
    onCancel()
  }

  const handleOk = () => setCheckForm(true)

  return (
    <Dialog sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 450 } }} maxWidth='xs' open={open} {...other}>
      <DialogTitle>{eventProp.id === undefined ? 'Nouvel événement' : eventProp.title}</DialogTitle>
      <DialogContent dividers>
        <Form
          options={options}
          checkForm={checkForm}
          setCheckForm={setCheckForm}
          setDataParent={setEvent}
          setIsSubmitParent={setIsSubmit}
          modeProps='wizard'
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Annuler</Button>
        <Button onClick={handleOk}>Enregistrer</Button>
      </DialogActions>
    </Dialog>
  )
}

export default EventDialog
